// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"classes_Paragraph__XIs4W","list":"classes_list__2uujE"};